import { render, staticRenderFns } from "./IconUid.vue?vue&type=template&id=5904c506&"
import script from "./IconUid.vue?vue&type=script&lang=js&"
export * from "./IconUid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports